import ViewTabTemplate from './viewTabTemplate';

export default ViewTabTemplate;
